import { createSlice } from '@reduxjs/toolkit'
import { MnuList } from 'app/core/models/api/com/com0102'
import { selectMnu0102 } from 'app/core/services/com/com.service'
import { RootState } from 'app/core/store'
/**
 * 메뉴 Store, 따로 설정하지 않는다. 지우지도 않는다. 업데이트만 존재할뿐!
 */
export type MenuDict = {
    [key: string]: MnuList
}
type MenuData = {
    dic: MenuDict
    items: MnuList[]
}
const slice = createSlice({
    name: 'menu',
    initialState: { dic: null, items: null } as MenuData,
    reducers: {},
    extraReducers: (builder) => {
        builder.addMatcher(selectMnu0102.matchFulfilled, (state, action) => {
            //raw data를 선 가공해서 적재시킨다.
            const rawMenus = action.payload.data ? [...action.payload.data] : []
            const dic: MenuDict = {}
            rawMenus.forEach((rawMenu, index) => {
                dic[rawMenu.menuId] = rawMenu
            })
            state.dic = dic
            state.items = rawMenus
        })
    },
})

export const selectorMenuData = (state: RootState) => {
    return state.menu
}

export const selectorMenuDic = (state: RootState) => {
    return state.menu.dic
}

export const selectorMenuItems = (state: RootState) => {
    return state.menu.items
}

export default slice.reducer
